import { CartProductUI } from './CartProductUI';
import { useEffectiveEquivalenceCharges } from '../../../user/application/useEffectiveEquivalenceCharges';
import { calculateDiscountPercentage } from '../../../helpers/calculateDiscountPercentage';
import { useCartContext } from '../../context/CartContext';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../../../user/infrastructure/UserContext';
import { useComercialContext } from '../../../comercial/ComercialContext';
export const CartProduct = ({ product, isDeprecated = false, displayQuantity, packParentName }) => {
  const { changeEquivalenceCharges, removeProduct, updateReceta, loadEspecies, updatePrecioManual } = useCartContext();
  const user = useUserContext();
  const { actingAsCliente } = useComercialContext();
  // Precio manual: solo comercial con permiso, pidiendo en nombre de un cliente, y nunca en líneas de pack
  const puedeCambiarPrecio = user?.cambiarPrecioCarrito === true && !!actingAsCliente
    && !product.packParentId && !product.packOrigin;
  const equivalenceCharges = useEffectiveEquivalenceCharges();
  const navigate = useNavigate();

  const editProduct = (product) => {
    navigate(`/articulos/${encodeURIComponent(product.code)}`);
  };

  return (
    <CartProductUI
      data={{
        product: product,
        productDiscount: product && calculateDiscountPercentage(product.basePrice, product.sellingPrice),
        promotionDiscount: product?.promotionDiscount ?? 0,
        userEquivalenceCharges: equivalenceCharges,
        isDeprecated: isDeprecated,
        displayQuantity: displayQuantity,
        packParentName: packParentName,
        puedeCambiarPrecio: puedeCambiarPrecio
      }}
      actions={{
        changeProductEquivalenceCharges: () => changeEquivalenceCharges(product),
        updateReceta: updateReceta,
        loadEspecies: loadEspecies,
        updatePrecioManual: updatePrecioManual,
        edit: () => editProduct(product),
        remove: () => removeProduct(product)
      }}
    />
  );
};